import { toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["for"];
const _hoisted_2 = {
  class: "relative"
};
const _hoisted_3 = {
  key: 0,
  class: "absolute slot-embeed z-10"
};
import { ref } from 'vue';
import LlTooltip from '@/components/LlTooltip.vue';
export default {
  __name: 'LlTextarea',
  props: {
    label: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: 'text-sm'
    },
    info: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      required: false
    },
    rows: {
      type: Number,
      default: 3
    },
    id: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'outlined'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: [Boolean, String],
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    dataCy: {
      type: String,
      default: ''
    },
    labelStyle: {
      type: String,
      required: false
    },
    noResize: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    autoGrow: {
      type: Boolean,
      default: false
    },
    maxRows: {
      type: Number,
      required: false
    },
    ariaLabel: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const textareaRef = ref(null);
    const props = __props;
    const emit = __emit;
    const handleUpdateValue = value => {
      emit('update:modelValue', value);
      emit('change', value);
    };
    __expose({
      focus: () => textareaRef.value?.focus()
    });
    return (_ctx, _cache) => {
      const _component_v_textarea = _resolveComponent("v-textarea");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("label", {
        for: __props.id || undefined,
        class: _normalizeClass(__props.labelClass),
        style: _normalizeStyle(__props.labelStyle)
      }, [_createTextVNode(_toDisplayString(__props.label) + " ", 1), _withDirectives(_createVNode(LlTooltip, {
        text: __props.info,
        icon: "help"
      }, null, 8, ["text"]), [[_vShow, __props.info.length]])], 14, _hoisted_1), _createElementVNode("div", _hoisted_2, [_createVNode(_component_v_textarea, {
        ref_key: "textareaRef",
        ref: textareaRef,
        "data-cy": __props.dataCy,
        modelValue: __props.modelValue,
        "onUpdate:modelValue": handleUpdateValue,
        rows: __props.rows,
        id: __props.id,
        variant: __props.variant,
        disabled: __props.disabled,
        readonly: __props.readonly,
        "bg-color": __props.readonly ? 'readonly-surface' : undefined,
        "hide-details": __props.hideDetails,
        rules: __props.rules,
        density: "compact",
        "no-resize": __props.noResize,
        placeholder: __props.placeholder,
        "auto-grow": __props.autoGrow,
        "max-rows": __props.maxRows,
        "aria-label": __props.ariaLabel || undefined
      }, null, 8, ["data-cy", "modelValue", "rows", "id", "variant", "disabled", "readonly", "bg-color", "hide-details", "rules", "no-resize", "placeholder", "auto-grow", "max-rows", "aria-label"]), _ctx.$slots.append ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_renderSlot(_ctx.$slots, "append")])) : _createCommentVNode("", true)])], 64);
    };
  }
};